var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.833 5.23h-3.5a.44.44 0 0 1-.437-.438.44.44 0 0 1 .437-.438h3.5a.44.44 0 0 1 .438.438.44.44 0 0 1-.438.437M4.5 5.23H2.167a.44.44 0 0 1-.438-.438.44.44 0 0 1 .438-.438H4.5a.44.44 0 0 1 .438.438.44.44 0 0 1-.438.437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.834 7.27a2.485 2.485 0 0 1-2.48-2.478 2.485 2.485 0 0 1 2.48-2.48 2.485 2.485 0 0 1 2.479 2.48 2.485 2.485 0 0 1-2.48 2.479m0-4.082a1.603 1.603 0 1 0 0 3.208 1.603 1.603 0 1 0 0-3.208M13.833 11.646H11.5a.44.44 0 0 1-.437-.438.44.44 0 0 1 .437-.437h2.333a.44.44 0 0 1 .438.437.44.44 0 0 1-.438.438M5.667 11.646h-3.5a.44.44 0 0 1-.438-.438.44.44 0 0 1 .438-.437h3.5a.44.44 0 0 1 .437.437.44.44 0 0 1-.437.438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.167 13.688a2.485 2.485 0 0 1-2.48-2.48 2.485 2.485 0 0 1 2.48-2.479 2.485 2.485 0 0 1 2.479 2.48 2.485 2.485 0 0 1-2.48 2.479m0-4.084a1.603 1.603 0 1 0 0 3.209 1.603 1.603 0 1 0 0-3.209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPassive);
export default __webpack_public_path__ + "static/media/settingsPassive.0167058a1121d52abd4e9a8917f2f4a0.svg";
export { ForwardRef as ReactComponent };